// setTimeout stores its delay in a signed 32-bit int and fires AT ONCE past it.
export const MAX_TIMER_MS = 2_147_483_647;
